import { ParentSize } from '@visx/responsive';
import * as React from 'react';

const Scene = React.lazy(() => import('./Scene'));

export type Props = {};

function App(props: Props) {
  const {} = props;
  return (
    <div style={{ width: '100%', height: '400px' }}>
      <ParentSize>{({ width, height }) => <Scene width={width} height={height} />}</ParentSize>
    </div>
  );
}

export default React.memo(App);
